module.exports = __webpack_public_path__ + "static/media/empty-box.b4b2091d.svg";